import { api } from '../utils/apiHelpers';
import { CityConfigsDto, MerchantConfigDTO } from './dtos/configs';
import { dtoToCityConfigs, dtoToMerchantConfig, dtoToServiceAreaConfig } from './transformers/configs';
import { sagwClient } from './clients';
import { MerchantConfig } from './models/configs';

export function fetchCityConfigs(cityIds: number[]) {
  return api
    .get<CityConfigsDto>('/v1/b2b/configs/city', {
      params: {
        city_ids: cityIds
      }
    })
    .then(dtoToCityConfigs);
}

export function fetchServiceArea(serviceAreas: number[]) {
  return sagwClient
    .get('/b2b/configs/serviceArea', {
      params: {
        service_area_ids: serviceAreas.join(',')
      }
    })
    .then(dtoToServiceAreaConfig);
}

export function fetchMerchantConfig(): Promise<MerchantConfig> {
  return sagwClient.get<MerchantConfigDTO>('/mot/merchants/current').then(dtoToMerchantConfig);
}
